const numExp = /^[0-9~`!@#$%^&* ()+=[];.,\/{}|":<>_\?]$/g;
const strExp = /^[a-zA-Z~`!@#$%^&* ()+=\-[]';.,\/{}|":<>\?]$/g; 
const strNumUnicodeExp = /^[A-Za-z0-9'&,ÀÁÂÄÇÈÉÊËÌÍÎÏÒÓÔÖàáâäçèéêëìíîïòóôöùúûüÙÚÛÜñÑ. _-]$/g;

/* eslint-disable no-useless-escape */
export function ccpaFormValidations(country) {
    const isCanada = country?.toUpperCase() === "CANADA";
    const emailUnicodeExp = /^[A-Za-z0-9'&,ÀÁÂÄÇÈÉÊËÌÍÎÏÒÓÔÖàáâäçèéêëìíîïòóôöùúûüÙÚÛÜñÑ@._-]{0,50}$/i;

    if (document.getElementById("firstName")) {
        document.getElementById("firstName").addEventListener("keypress", e => {
            const value = e.key;
            if (isCanada) {
                if (!strNumUnicodeExp.test(value)) {
                    e.preventDefault();
                }
            } else if (numExp.test(value)) {
                e.preventDefault();
            }
            e.target.setAttribute('maxlength', '40')
        });
    }

    if (document.getElementById("middleInitial")) {
        document.getElementById("middleInitial").addEventListener("keypress", e => {
            const value = e.key;
            if (isCanada) {
                if (!/^[A-Za-z ÀÁÂÄÇÈÉÊËÌÍÎÏÒÓÔÖàáâäçèéêëìíîïòóôöùúûüÙÚÛÜñÑ]$/g.test(value)) {
                    e.preventDefault();
                }
            } else if (numExp.test(value)) {
                e.preventDefault();
            }
            e.target.setAttribute('maxlength', '1')
        });
    }

    if (document.getElementById("lastName")) {
        document.getElementById("lastName").addEventListener("keypress", e => {
            const value = e.key;
            if (isCanada) {
                if (!strNumUnicodeExp.test(value)) {
                    e.preventDefault();
                }
            } else if (numExp.test(value)) {
                e.preventDefault();
            }
            e.target.setAttribute('maxlength', '40')
        });
    }

    if (document.getElementById("emailAddress")) {
        document.getElementById("emailAddress").addEventListener("keypress", e => {
            const value = e.key;
            if (isCanada) {
                if (!emailUnicodeExp.test(value)) {
                    e.preventDefault();
                }
            } else if (/^[\()\[\]\,\":< >\?]$/g.test(value)) {
                e.preventDefault();
            }
        });
    }

    if (document.getElementById("reEnterEmailAddress")) {
        document.getElementById("reEnterEmailAddress").addEventListener("keypress", e => {
            const value = e.key;
            if (isCanada) {
                if (!emailUnicodeExp.test(value)) {
                    e.preventDefault();
                }
            } else if (/^[\()\[\]\,\":< >\?]$/g.test(value)) {
                e.preventDefault();
            }
        });
    }

    if (document.getElementById("reEnterEmailAddress")) {
        document.getElementById("reEnterEmailAddress").addEventListener("paste", e => {
            e.preventDefault();
        });
    }

    if (document.getElementById("ssn")) {
        document.getElementById("ssn").addEventListener("keypress", e => {
            const value = e.key;
            if (strExp.test(value)) {
                e.preventDefault();
            }
        });
    }

    if (document.getElementById("vin")) {
        document.getElementById("vin").addEventListener("keypress", e => {
            e.target.setAttribute('maxlength', '17')
            const value = e.key;
            if (/^[~`!@#$%\^&* ()+=\-\[\]\';.,/{}|\":<>\?]$/g.test(value)) {
                e.preventDefault();
            }
        });
    }

    if (document.getElementById("phone")) {
        document.getElementById("phone").setAttribute('maxlength', '14');
    }
}
export function mailingAddressValidations(country) {
    const isCanada = country?.toUpperCase() === "CANADA";
    const addressUnicodeExp = /^[A-Za-z0-9'&,ÀÁÂÄÇÈÉÊËÌÍÎÏÒÓÔÖàáâäçèéêëìíîïòóôöùúûüÙÚÛÜñÑ. _-]$/i;

    if (document.getElementById("select-state")) {
        document.getElementById("select-state").setAttribute('selected', '');
    }

    if (document.getElementById("addressLine1")) {
        document.getElementById("addressLine1").addEventListener("keypress", e => {
            e.target.setAttribute('maxlength', '80')
            const value = e.key;
            if (isCanada) {
                if (!addressUnicodeExp.test(value)) {
                    e.preventDefault();
                }
            } else if (/^[~`@$%\^*()+=\[\]\;/{}|\:<>\?]$/g.test(value)) {
                e.preventDefault();
            }
        });
    }

    if (document.getElementById("addressLine2")) {
        document.getElementById("addressLine2").addEventListener("keypress", e => {
            e.target.setAttribute('maxlength', '80')
            const value = e.key;
            if (isCanada) {
                if (!addressUnicodeExp.test(value)) {
                    e.preventDefault();
                }
            } else if (/^[~`@$%\^*()+=\[\]\;/{}|\:<>\?]$/g.test(value)) {
                e.preventDefault();
            }
        });
    }

    if (document.getElementById("city")) {
        document.getElementById("city").addEventListener("keypress", e => {
            e.target.setAttribute('maxlength', '40')
            const value = e.key;
            if (isCanada) {
                if (!strNumUnicodeExp.test(value)) {
                    e.preventDefault();
                }
            } else if (/^[0-9~`!@#$%\^&*()+=\-\[\]\';.,/{}|\":<>\?]$/g.test(value)) {
                e.preventDefault();
            }
        });
    }

    if (document.getElementById("postalCode")) {
        document.getElementById("postalCode").addEventListener("keypress", e => {
            e.target.setAttribute('maxlength', '7')
            const value = e.key;
            if (/^[~`!@#$%\^&*()+=\-\[\]\';.,/{}|\":<>\?]$/g.test(value)) {
                e.preventDefault();
            }
        });
    }
}

export function verificationFormValidations() {
    if (document.getElementById("lastName")) {
        document.getElementById("lastName").addEventListener("keypress", e => {
            const value = e.key;
            if (numExp.test(value)) {
                e.preventDefault();
            }
            e.target.setAttribute('maxlength', '40')
        });
    }

    if (document.getElementById("last4Ssn")) {
        document.getElementById("last4Ssn").addEventListener("keypress", e => {
            e.target.setAttribute('maxlength', '4')
            const value = e.key;
            if (strExp.test(value)) {
                e.preventDefault();
            }
        });
    }

    if (document.getElementById("confirmationNumber")) {
        document.getElementById("confirmationNumber").addEventListener("keypress", e => {
            const value = e.target.value;
            const isVWGoAConfirmationNumber = value.startsWith('VWGOA');
            e.target.setAttribute('maxlength', isVWGoAConfirmationNumber ? '14' : '8');

            const key = e.key;
            if (/[~`!@#$%\^&*()+=\-\[\]\';. ,/{}|\":<>\?]/g.test(key)) {
                e.preventDefault();
            }
        });

        document.getElementById("confirmationNumber").addEventListener("paste", e => {
            const value = e.clipboardData.getData('text');
            const isVWGoAConfirmationNumber = value.startsWith('VWGOA');
            e.target.setAttribute('maxlength', isVWGoAConfirmationNumber ? '14' : '8');

            e.preventDefault();
            e.target.value = value.slice(0, isVWGoAConfirmationNumber? 14 : 8)
        });
    }

    if (document.getElementById("pinNumber")) {
        document.getElementById("pinNumber").addEventListener("keypress", e => {
            e.target.setAttribute('maxlength', '4')
            const value = e.key;
            if (strExp.test(value)) {
                e.preventDefault();
            }
        });
    }
}
export function pinFormValidations() {
    if (document.getElementById("pinNumber")) {
        document.getElementById("pinNumber").addEventListener("keypress", e => {
            e.target.setAttribute('maxlength', '4')
            const value = e.key;
            if (strExp.test(value)) {
                e.preventDefault();
            }
        });
    }

    if (document.getElementById("reEnterPinNumber")) {
        document.getElementById("reEnterPinNumber").addEventListener("keypress", e => {
            e.target.setAttribute('maxlength', '4')
            const value = e.key;
            if (strExp.test(value)) {
                e.preventDefault();
            }
        });
    }
}
